import { userConstants } from '../constants';

const initialState = {
    user: null
};

export function users(state = initialState, action) {
    switch (action.type) {
        case userConstants.LOGIN_SUCCESS:
            return {
                user: action.user.user[0]
            };
        case userConstants.LOGOUT: 
            return initialState;
        case userConstants.LOGIN_FAILURE:
            return {
                ...state,
            };
        case userConstants.RESET_SUCCESS:
            return {
                // user: action.user.userExists
            };
        case userConstants.RESET_FAILURE:
            return initialState;
        case userConstants.GETALL_REQUEST:
            return {
                loading: true,
            };
        case userConstants.GETUSER_SUCCESS:
            return {
                user: action.users
            };
        case userConstants.GETALL_SUCCESS:
            return {
                items: action.users
            };
        case userConstants.GETALL_FAILURE:
            return {
                error: action.error
            };
        case userConstants.DELETE_REQUEST:
            // add 'deleting:true' property to user being deleted
            return {
                ...state,
                items: state.items.map(user =>
                    user.id === action.id
                        ? { ...user, deleting: true }
                        : user
                )
            };
        case userConstants.DELETE_SUCCESS:
            // remove deleted user from state
            return {
                items: state.items.filter(user => user.id !== action.id)
            };
        case userConstants.DELETE_FAILURE:
            // remove 'deleting:true' property and add 'deleteError:[error]' property to user
            return {
                ...state,
                items: state.items.map(user => {
                    if (user.id === action.id) {
                        // make copy of user without 'deleting:true' property
                        const { deleting, ...userCopy } = user;
                        // return copy of user with 'deleteError:[error]' property
                        return { ...userCopy, deleteError: action.error };
                    }

                    return user;
                })
            };
        case userConstants.UPDATE_SUCCESS:
            return {
                ...state,
                user: action.user
            }
        default:
            return state
    }
}